import { useState } from "react";
import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import api from "../services/api";
import "../style/contact.css";

import { getErrorMessage } from "../utils/apiError";

const Contact = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    setLoading(true);

    try {
      const res = await api.post(
        "/contact",
        form
      );
      setSuccess(res.data?.message || "Message sent successfully.");
      setForm({
        name: "",
        email: "",
        message: ""
      });
    } catch (err) {
      setError(getErrorMessage(err, "Failed to send message. Please try again."));
    } finally {
      setLoading(false);
    }
  };


  return (

    <>

      <WebsiteNavbar />

      <div className="contact-page">

        <div className="contact-hero">

         <h1>Get In <span>Touch</span></h1>

          <p>
            Need a skip bin? Have questions about pricing,
            waste types or delivery?<br />
            We're here to help.
          </p>

        </div>

        <div className="contact-card">

          <div className="contact-container">

            {/* LEFT */}

            <div className="contact-info">

              <h2>
                Contact Information
              </h2>

              <div className="contact-info-item">

                <span>📞</span>

                <div>
                  <h4>Phone</h4>
                  <p>+61 0495 000 017</p>
                </div>

              </div>

              <div className="contact-info-item">

                <span>✉️</span>

                <div>
                  <h4>Email</h4>
                  <p>admin@jerrysbinsperth.com.au</p>
                </div>

              </div>

              <div className="contact-info-item">

                <span>📍</span>

                <div>
                  <h4>Service Area</h4>
                  <p>Perth, Western Australia</p>
                </div>

              </div>

            </div>

            {/* RIGHT */}

            <div className="contact-form">

              <h2>
                Send Us A Message
              </h2>

              {success && (
                <div className="contact-success">
                  {success}
                </div>
              )}

              {error && (
                <div className="contact-error">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>

                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={form.email}
                  onChange={handleChange}
                  required
                />

                <textarea
                  name="message"
                  placeholder="How can we help you?"
                  value={form.message}
                  onChange={handleChange}
                  required
                />

                <button
                  className="contact-btn"
                  type="submit"
                  disabled={loading}
                >
                 {loading ? "Sending..." : "Send Message"}
                </button>


              </form>

            </div>

          </div>

        </div>

      </div>

      <Footer />

    </>

  );

};

export default Contact;